import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./addDealerForm.module.scss";
import FormikControl from "../../../../components/formComponents/FormikControl";
import i18next from "i18next";
import {
  dropdownValueYesNo,
  getDropDownValue,
  statusOptions,
  getValueKey,
} from "../../../../config/appConfig";
import { useFormikContext } from "formik";
import _ from "lodash";
import loaderAnimation from "../../../../assets/lotties/loader.json";
import Lottie from "lottie-react";
import {
  getCertificatesList,
  getExactDetails,
  getSoftwareList,
  getSourceList,
  getExactDealerList,
  GetExactSetting,
} from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import CustomModalDialog from "../../../../components/modal/CustomModalDialog";
import PropTypes from "prop-types";

const DealerDetailsFormSection = (props) => {
  const { provinceList } = props;

  const { setApiErrorModalState } = useApiErrorModalContext();
  const [isExistingDealerFlag, setIsExistingDealerFlag] = useState(false);
  const [extractDeatilsLoadingFlag, setExtractDeatilsLoadingFlag] =
    useState(false);
  const [exactListLoadingFlag, setExactListLoadingFlag] = useState(false);
  const [exactDynamicError, setExactDynamicError] = useState(
    i18next.t("Dealer already exist in system")
  );
  const [assignCertificatesOptions, setAssignCertificatesOptions] = useState(
    []
  );
  const [bornOptions, setBornOptions] = useState([]);
  const [softwareList, setSoftwareList] = useState([]);
  const [exactList, setExactList] = useState([]);
  const [hexonDealerName, setHexonDealerName] = useState("");
  const [duplicateExactPopup, setDuplicateExactPopup] = useState(false);
  const [exactCertificateList, setExactCertificateList] = useState([]);
  const [certificateWarning, setCertificateWarning] = useState(false);
  const [isAutomaticExact, setIsAutomaticExact] = useState(null);

  const hasErrorCheck = (formikProps, name) => {
    return !!(formikProps?.touched[name] && formikProps?.errors[name]);
  };
  const fetchExactDropDownList = (params = {}) => {
    getExactDealerList(params)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          setExactListLoadingFlag(false);
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setExactListLoadingFlag(false);

          setExactList(response);
        }
      })
      .catch((err) => {
        setExactListLoadingFlag(false);

        setApiErrorModalState({ error: err });
      });
  };

  useEffect(() => {
    fetchExactDropDownList({});
    getCertificatesList({})
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setAssignCertificatesOptions(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });

    // sourcelist
    getSourceList({})
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setBornOptions(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });

    getSoftwareList()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setSoftwareList(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });

    GetExactSetting()
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          const isAuto = _.isEqual(_.get(response, 'value', 'automatic'), 'automatic')
          setIsAutomaticExact(isAuto);
          localStorage.setItem('isExactAutomatic', isAuto);
        }
      }).catch((err) => {
        setApiErrorModalState({ error: err });
      });

    if (document.getElementById("addDealerFormWrapper")) {
      document.getElementById("addDealerFormWrapper").scrollIntoView =
        function () { };
      if (isAutomaticExact) {
        document.getElementById("exact_Number").focus();
      }

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onExactInputChange = (searchTerm) => {
    setExactListLoadingFlag(true);
    let searchValue = searchTerm?.split(":");

    if (!exactListLoadingFlag || searchTerm?.length === 0) {
      searchValue?.length < 2
        ? fetchExactDropDownList({ searchTerm: searchTerm })
        : fetchExactDropDownList({ searchTerm: searchValue[0] });
    }
  };

  const formikProps = useFormikContext();

  const setDropdownValue = (value, dropdownOptions, name) => {
    let selectedOption = getDropDownValue(value, dropdownOptions);
    formikProps?.setFieldValue(name, selectedOption);
    formikProps?.setFieldTouched(name, false);
  };

  const resetExactFields = (clearDealerName = true) => {
    if (clearDealerName) {
      setHexonDealerName("");
      formikProps.setFieldValue("dealer_Name", hexonDealerName);
    }

    formikProps?.setFieldValue("provider_Number", "");
    formikProps?.setFieldValue("bovag_Number", "");
    formikProps?.setFieldValue("province", "");
    formikProps?.setFieldTouched("exact_Number", false);
    formikProps?.setFieldValue("kvK_Number", "");

    setExtractDeatilsLoadingFlag(false);
  };
  const getKeyValue = (list, value) => {
    const keyValue = list.filter((option) => {
      return option.key === value
    });
    return keyValue[0];
  }

  const setExactFormField = (response) => {
    setHexonDealerName(formikProps?.values.dealer_Name);
    formikProps.setFieldValue(
      "dealer_Name",
      _.isNull(_.get(response, "dealer_Name", ""))
        ? ""
        : _.get(response, "dealer_Name", "")
    );

    if (response?.status === "C") {
      formikProps.setFieldTouched("dealer_Name", false);
    }
    formikProps.setFieldTouched("dealer_Name", false);

    formikProps.setFieldValue(
      "provider_Number",
      _.isNull(_.get(response, "provider_Number", null))
        ? "Onbekend"
        : _.get(response, "provider_Number", "")
    );
    formikProps.setFieldTouched("provider_Number", false);

    formikProps.setFieldValue(
      "bovag_Number",
      _.isNull(_.get(response, "bovag_Number", ""))
        ? ""
        : _.get(response, "bovag_Number", "")
    );
    formikProps.setFieldTouched("bovag_Number", false);

    formikProps.setFieldValue(
      "province",
      _.isNull(_.get(response, "province", null))
        ? getKeyValue(provinceList, "Onbekend")
        : getKeyValue(provinceList, _.get(
          response,
          "province", ""))
    );
    formikProps.setFieldValue(
      "kvK_Number",
      _.isNull(_.get(response, "kvk_Number", null))
        ? ""
        : _.get(response, "kvk_Number", null)
    );
    formikProps.setFieldTouched("province", false);
    formikProps.setFieldValue(
      "kvK_Number",
      _.isNull(_.get(response, "kvk_Number", null))
        ? ""
        : _.get(response, "kvk_Number", null)
    );
    setIsExistingDealerFlag(false);
    setExactCertificateList(
      _.get(
        response,
        "subscription_Type", null)
    );

    formikProps.setFieldValue(
      "Assign_Certificates",
      getValueKey(_.get(
        response,
        "subscription_Type", []), assignCertificatesOptions)
    );
    setExtractDeatilsLoadingFlag(false);
  };
  const fetchExactData = (value) => {
    if (_.isEmpty(value)) {
      setIsExistingDealerFlag(false);
      return;
    }
    setExtractDeatilsLoadingFlag(true);

    getExactDetails({ exactNumber: value })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);
          if (
            _.get(response, "success", true) === false &&
            _.get(response, "message", "") === "Exact number not found"
          ) {
            if(isAutomaticExact) {
              setExactDynamicError("Exact-nummer bestaat niet");
              setIsExistingDealerFlag(true);
              resetExactFields();
            }       
          } else {
            if(isAutomaticExact) {
              setApiErrorModalState({ error: response });
              resetExactFields();
            }
          }

          
        } else {
          setExactFormField(response);
          response.exactDuplicate
            ? setDuplicateExactPopup(true)
            : setDuplicateExactPopup(false);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
        setIsExistingDealerFlag(false);
        resetExactFields();

        setExtractDeatilsLoadingFlag(false);
      });
  };

  const handleCertificateMatch = (value = [], CertificateList = []) => {
    if (_.isUndefined(CertificateList) || _.isEmpty(CertificateList)) {
      setCertificateWarning(false);
    } else if (value.length !== CertificateList.length) {
      setCertificateWarning(true);
    } else {
      setCertificateWarning(false);
    }
  };
  useEffect(() => {
    if (!_.isEmpty(props.exactSubcriptionList.certificate)) {
      setExactCertificateList(props.exactSubcriptionList.certificate);
      handleCertificateMatch(props.exactSubcriptionList.value, props.exactSubcriptionList.certificate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loader = () => (
    <Lottie
      animationData={loaderAnimation}
      loop={true}
      height={"21px"}
      width={"21px"}
    />
  );

  const resetDealerNameToHexon = () => {
    setHexonDealerName("");
    formikProps.setFieldValue("dealer_Name", hexonDealerName);
  };

  return (
    <Box
      className={`formWrapper ${styles.detailsSectionWrapper}`}
      data-testid="detailsform"
    >
      <Box className={`textboxDoubleWraper ${styles.fieldWithLoader}`}>

        {isAutomaticExact ?
          <Box sx={{ display: "flex" }}>
            <FormikControl
              control="autocomplete"
              options={exactListLoadingFlag ? [] : exactList}
              hiddenLabel
              noOptionsText={
                <Box>
                  <Box>{i18next.t("No results found")}</Box>
                </Box>
              }
              loading={exactListLoadingFlag}
              size="small"
              variant="filled"
              className={`input-grp__box ${styles.inputBox}${formikProps?.errors?.exact_Number ? "errorInput" : ""
                }`}
              label={i18next.t("Exact match")}
              id="exact_Number"
              name="exact_Number"
              isSelect={false}
              placeholder={i18next.t("Enter dealer exact match")}
              value={formikProps?.values.exact_Number}
              hasSubText={true}
              subTextField={{
                title: "key",
                id: "value",
              }}
              hasShowKeyValuePair={true}
              onChange={(e, value) => {
                setDropdownValue(value, exactList, "exact_Number");
                resetExactFields(false);
                setExactListLoadingFlag(true);
                fetchExactData(value?.value);
              }}

              onInputChange={(event, newInputValue) => {
                onExactInputChange(newInputValue);
              }}
              error={
                (formikProps?.touched.exact_Number &&
                  formikProps?.errors.exact_Number) ||
                isExistingDealerFlag
              }
              errorMessage={
                isExistingDealerFlag
                  ? exactDynamicError
                  : formikProps?.errors?.exact_Number
              }
            />
            {extractDeatilsLoadingFlag ? (
              <Box className={styles.loaderWrapper}>{loader()}</Box>
            ) : (
              <Box>
              </Box>
            )}
          </Box>
          :
          <FormikControl
            control="textfield"
            type="number"
            hiddenLabel
            size="small"
            variant="filled"
            className={`input-grp__box`}
            label={i18next.t("Exact match")}
            id="exact_number_manual"
            name="exact_number_manual"
            placeholder={i18next.t("Exact match")}
            value={formikProps?.values.exact_number_manual}
            // inputProps={{ maxLength: 7 }}
            inputProps={{ inputMode: 'numeric' }}
            onChange={(e) => {

              let value = _.get(e, "target.value", "");
              if (value?.length <= 7) {
                formikProps?.setFieldTouched("exact_number_manual", false);
                formikProps?.setFieldValue("exact_number_manual", value);
              } else {

                formikProps?.setFieldValue("exact_number_manual", value.slice(0, -1));
              }
            }}
            onBlur={(e) => {
              const value = _.get(e, "target.value", "");
              setExactListLoadingFlag(true);
              fetchExactData(value);
            }}
            error={hasErrorCheck(formikProps, "exact_number_manual")}
            errorMessage={formikProps?.errors?.exact_number_manual}
            disabled={false}
          />
        }
      </Box>


      <Box className="textboxDoubleWraper">
        <Box>
          <FormikControl
            control="textfield"
            type="text"
            hiddenLabel
            size="small"
            variant="filled"
            className={`input-grp__box`}
            label={i18next.t("Dealer name")}
            id="dealer_Name"
            name="dealer_Name"
            placeholder={i18next.t("Enter dealer name")}
            value={formikProps?.values.dealer_Name}
            onChange={(e) => {
              let value = _.get(e, "target.value", "");

              formikProps?.setFieldTouched("dealer_Name", false);
              formikProps?.setFieldValue("dealer_Name", value);
            }}
            error={hasErrorCheck(formikProps, "dealer_Name")}
            errorMessage={formikProps?.errors?.dealer_Name}
          />
          {!_.isEmpty(hexonDealerName) ? (
            <Box
              onClick={() => resetDealerNameToHexon()}
              onKeyDown={() => { }}
              className={styles.existingDealerLink}
            >
              {`${i18next.t("Wil je terug naar deze Naam uit KBS")}`}:{" "}
              {hexonDealerName}
              {"?"}
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Box>

      <Box className="textboxDoubleWraper">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Provider no.")}
          id="provider_Number"
          name="provider_Number"
          placeholder={i18next.t("Provider no.")}
          inputProps={{ maxLength: 20 }}
          value={formikProps?.values.provider_Number}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("provider_Number", false);
            formikProps?.setFieldValue("provider_Number", value);
          }}
          error={hasErrorCheck(formikProps, "provider_Number")}
          errorMessage={formikProps?.errors?.provider_Number}
          disabled={isAutomaticExact}
        />
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Bovag no.")}
          id="bovag_Number"
          name="bovag_Number"
          placeholder={i18next.t("Bovag no.")}
          inputProps={{ maxLength: 20 }}
          disabled={isAutomaticExact}
          value={formikProps?.values.bovag_Number}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("bovag_Number", false);
            formikProps?.setFieldValue("bovag_Number", value);
          }}
          error={
            !!(
              formikProps?.touched.bovag_Number &&
              formikProps?.errors.bovag_Number
            )
          }
          errorMessage={formikProps?.errors?.bovag_Number}
        />
      </Box>
      <Box className="textboxDoubleWraper">
        {/* <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Province")}
          id="province"
          name="province"
          placeholder={i18next.t("Province")}
          value={formikProps?.values.province}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("province", false);
            formikProps?.setFieldValue("province", value);
          }}
          error={hasErrorCheck(formikProps, "province")}
          errorMessage={formikProps?.errors?.province}
          disabled={true}
        /> */}
        <FormikControl
          control="autocomplete"
          dropDownEnabled={isAutomaticExact}
          options={provinceList}
          hiddenLabel
          noOptionsText={
            <Box>
              <Box>{i18next.t("No results found")}</Box>
            </Box>
          }
          loading={exactListLoadingFlag}
          size="small"
          variant="filled"
          className={`input-grp__box ${styles.inputBox}${formikProps?.errors?.province ? "errorInput" : ""
            }`}
          label={i18next.t("Province")}
          id="province"
          name="province"
          isSelect={false}
          placeholder={i18next.t("Province")}
          value={formikProps?.values.province}

          hasShowKeyValuePair={false}
          disabled={isAutomaticExact}


          onChange={(e, value) => {
            //setDropdownValue(value, provinceList, "province");
            formikProps?.setFieldValue("province", value);
          }}

          // onInputChange={(event, newInputValue) => {
          //   onExactInputChange(newInputValue);
          // }}
          error={
            (formikProps?.touched.province &&
              formikProps?.errors.province) ||
            isExistingDealerFlag
          }
          errorMessage={
            isExistingDealerFlag
              ? exactDynamicError
              : formikProps?.errors?.province
          }
        />
      </Box>
      <Box className="textboxDoubleWraper">
        <FormikControl
          variant="filled"
          control="autocomplete"
          label={i18next.t("Status")}
          options={statusOptions}
          hiddenLabel
          id="dealer_Status"
          name="dealer_Status"
          size="small"
          isSelect={true}
          disabled={false}
          onChange={(e, value) => {
            setDropdownValue(value, statusOptions, "dealer_Status");
          }}
          value={formikProps?.values.dealer_Status}
          error={hasErrorCheck(formikProps, "dealer_Status")}
          hasError={hasErrorCheck(formikProps, "dealer_Status")}
          errorMessage={formikProps?.errors?.dealer_Status}
          placeholder={i18next.t("Select Status")}
          className="input-grp__box select"
        />
        <Box>
          <FormikControl
            variant="filled"
            control="multiselect"
            label="Assign certificates"
            options={assignCertificatesOptions}
            hiddenLabel
            id="multiSelectDropdown"
            name="Assign_Certificates"
            size="small"
            isSelect={true}
            disabled={isAutomaticExact}
            getOptionDisabled={(option) =>
              formikProps?.values?.dealer_Status?.key !== "Ja"
            }
            //placeholder={i18next.t("Select certificates")}
            className="input-grp__box select"
            freeSolo={false}
            onChange={(e, value) => {
              formikProps?.setFieldTouched("Assign_Certificates", false);
              let keyArrayItems = value?.map((certificate) => certificate.key);
              if (
                _.includes(keyArrayItems, "Select All") &&
                formikProps?.values.Assign_Certificates.length ===
                assignCertificatesOptions.length
              ) {
                value = [];
              } else if (
                _.includes(keyArrayItems, "Select All") &&
                formikProps?.values.Assign_Certificates.length !==
                assignCertificatesOptions.length
              ) {
                value = assignCertificatesOptions;
              }

              formikProps?.setFieldValue("Assign_Certificates", value);
              handleCertificateMatch(value, exactCertificateList);
            }}
            value={formikProps?.values.Assign_Certificates}
            error={hasErrorCheck(formikProps, "Assign_Certificates")}
            hasError={hasErrorCheck(formikProps, "Assign_Certificates")}
            errorMessage={formikProps?.errors?.Assign_Certificates}
          />
          {certificateWarning ? (
            <Box className={styles.existingCertificate}>
              {`${i18next.t("*Niet overeen met Exact")}`}
            </Box>
          ) : (
            ""
          )}
        </Box>
      </Box>
      <Box className="textboxDoubleWraper">
        <FormikControl
          variant="filled"
          control="autocomplete"
          label="Combine certificates"
          options={dropdownValueYesNo}
          hiddenLabel
          id="combine_Certificate"
          name="combine_Certificate"
          size="small"
          isSelect={true}
          disabled={false}
          placeholder={i18next.t("Select Certifiacate")}
          className="input-grp__box select"
          value={formikProps?.values.combine_Certificate}
          onChange={(e, value) => {
            setDropdownValue(value, dropdownValueYesNo, "combine_Certificate");
          }}
          error={hasErrorCheck(formikProps, "combine_Certificate")}
          hasError={hasErrorCheck(formikProps, "combine_Certificate")}
          errorMessage={formikProps?.errors?.combine_Certificate}
        />
      </Box>
      <Box className="textboxDoubleWraper">
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("Kvk Number")}
          id="kvK_Number"
          name="kvK_Number"
          placeholder={i18next.t("Enter KvK number")}
          value={formikProps?.values.kvK_Number}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("kvK_Number", false);
            formikProps?.setFieldValue("kvK_Number", value);
          }}
          error={hasErrorCheck(formikProps, "kvK_Number")}
          errorMessage={formikProps?.errors?.kvK_Number}
        />
        <FormikControl
          control="textfield"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={i18next.t("KvK vestigingsnummer")}
          id="kvK_Vestigings_Number"
          name="kvK_Vestigings_Number"
          placeholder={i18next.t("Enter KvK vestigingsnumme")}
          value={formikProps?.values.kvK_Vestigings_Number}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("kvK_Vestigings_Number", false);
            formikProps?.setFieldValue("kvK_Vestigings_Number", value);
          }}
          error={hasErrorCheck(formikProps, "kvK_Vestigings_Number")}
          errorMessage={formikProps?.errors?.kvK_Vestigings_Number}
        />
      </Box>
      <Box className="textboxDoubleWraper">
        <FormikControl
          variant="filled"
          control="autocomplete"
          label="Software systeem"
          options={softwareList}
          hiddenLabel
          id="software_System"
          name="software_System"
          size="small"
          onChange={(e, value) => {
            setDropdownValue(value, softwareList, "software_System");
            // eslint-disable-next-line react-hooks/exhaustive-deps
          }}
          value={formikProps?.values.software_System}
          error={hasErrorCheck(formikProps, "software_System")}
          hasError={hasErrorCheck(formikProps, "software_System")}
          errorMessage={formikProps?.errors?.software_System}
          placeholder={i18next.t("Select the Software systeem")}
          className="input-grp__box select"
          helpertext={{ label: "(voor adverteren auto's)", value: "" }}
        />

        <FormikControl
          variant="filled"
          control="autocomplete"
          label="Bron"
          options={bornOptions}
          hiddenLabel
          id="source_System_Id"
          name="source_System_Id"
          size="small"
          onChange={(e, value) => {
            setDropdownValue(value, bornOptions, "source_System_Id");
            // eslint-disable-next-line react-hooks/exhaustive-deps
          }}
          value={formikProps?.values.source_System_Id}
          error={hasErrorCheck(formikProps, "source_System_Id")}
          hasError={hasErrorCheck(formikProps, "source_System_Id")}
          errorMessage={formikProps?.errors?.source_System_Id}
          placeholder={i18next.t("Select the Dealer Bron")}
          className="input-grp__box select"
        />
      </Box>
      <Box className="textAreaWrapper">
        <FormikControl
          control="textarea"
          type="text"
          hiddenLabel
          size="small"
          variant="filled"
          className={`input-grp__box`}
          label={`Opmerkingen (${i18next.t("Optional")})`}
          id="comments"
          name="comments"
          placeholder={i18next.t("Enter Comments here...")}
          value={formikProps?.values?.comments}
          onChange={(e) => {
            let value = _.get(e, "target.value", "");

            formikProps?.setFieldTouched("comments", false);
            formikProps?.setFieldValue("comments", value);
          }}
          error={hasErrorCheck(formikProps, "comments")}
          errorMessage={formikProps?.errors?.comments}
        />
      </Box>
      {duplicateExactPopup ? (
        <CustomModalDialog
          isShow={duplicateExactPopup}
          title="Duplicate Exact"
          onClose={() => setDuplicateExactPopup(false)}
          // children
          // className
          isCloseButton={false}
          doScrollToTop={false}
          isShowHeader={true}
          hasFooter={true}
          cancelBtnLabel="Yes"
          primaryButnFn={() => {
            resetExactFields();
            setDuplicateExactPopup(false);
          }}
          primaryBtnLabel="No"
          handleClose={() => setDuplicateExactPopup(false)}
        >
          <Box>{i18next.t("Do you really want to add duplicate?")}</Box>
        </CustomModalDialog>
      ) : null}
    </Box>
  );
};
export default DealerDetailsFormSection;
DealerDetailsFormSection.propTypes = {
  exactSubcriptionList: PropTypes.any,
  provinceList: PropTypes.any
}